import { render } from "./AntiBullyingDetail.vue?vue&type=template&id=4e4824e4&scoped=true"
import script from "./AntiBullyingDetail.vue?vue&type=script&lang=js"
export * from "./AntiBullyingDetail.vue?vue&type=script&lang=js"

import "./AntiBullyingDetail.vue?vue&type=style&index=0&id=4e4824e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4824e4"]])

export default __exports__